module.exports = __webpack_public_path__ + "static/media/como-26.80eabd9a.jpg";